export default "06f5cd7d44bc64a1.svg"